export default class MobileFooterNavigation {
    constructor() {
        this.init();
    }

    init() {
        let navigation = document.querySelector( '.footer__mobile-widgets__column--navigation-mobile' );
        let newsletter = document.querySelector( '.footer__mobile-widgets__column--newsletter-mobile' );

        if ( navigation !== null ) {
            let navigationItems = navigation.querySelectorAll( '.menu-item-has-children' );
            navigationItems.forEach( ( item ) => {
                item.addEventListener( 'click', ( e ) => {
                    e.preventDefault();
                    item.classList.toggle( 'item-opened' );
                } );
            } );
        }

        if ( newsletter !== null ) {
            let newsletterTitle = newsletter.querySelector( '.newsletter__title' );
            newsletterTitle.addEventListener( 'click', ( e ) => {
                e.preventDefault();
                newsletter.classList.toggle( 'newsletter-opened' );
            } );
        }
    }
}
